import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";

import { Common, SUCCESS, VALIDATION } from "../../../helper";
import * as commonApi from "../../../api/commonApi";
import { isEmptyArray, isEmptyObject } from "../../../util";
import { styles } from "../"
import { success } from "../../Shared";

import "../../../assets/stlyes/Modals.css";

const AssignClass = (props) => {
  const { isUserId, setAssignClass, getData } = props;
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedSujects, setSelectedSujects] = useState(null);
  const [selectedOverallSujects, setSelectedOverallSujects] = useState(null);
  const [classOptions, setClassOptions] = useState();
  const [classId, setClassId] = useState();
  const [classes, setClasses] = useState("");
  const [sub, setSub] = useState("");
  const [errMessage, setErrMessage] = useState(false);
  const [errMessage1, setErrMessage1] = useState(false);

  const getAllClasses = async () => {
    const adminClass = await commonApi.getClassBySchoolId({ userId: isUserId });
    if (!isEmptyArray(adminClass.Items)) {
      const adminClasses = adminClass.Items.map((item) => ({ value: item.classId, label: item.className }));
      setClassOptions(adminClasses);
    }
  }

  const getAllSubjects = async (e) => {
    setClassId(e.value);
    const getSubjects = await commonApi.getSubjectByClassId({ userId: isUserId, classId: e.value });
    if (!isEmptyArray(getSubjects.Items)) {
      const subjectIds = getSubjects.Items.map((idz) => (idz.id))
      const subjects = getSubjects.Items.map((item) => ({ value: item.id, label: item.subjectName }));
      setSelectedSujects([{ value: subjectIds, label: "All" }, ...subjects]);
      setSelectedOverallSujects([{ value: subjectIds, label: "All" }, ...subjects]);
    }
  }

  const AssignClasses = async (classData, setSubmitting) => {
    setSubmitting(true);
    const classDetails = await commonApi.assignClass(classData);
    if (!isEmptyObject(classDetails)) {
      success(`${SUCCESS.CLASS_SUBJECT_ASSIGNED} ${classDetails.Items.firstName} ${classDetails.Items.lastName}`)
      getData();
      setSubmitting(false);
    }else{
      setSubmitting(false);
    }
  }



  useEffect(() => {
    getAllClasses();
  }, [])
  return (
    <Formik
      initialValues={{
        selectClass: "",
        selectSubjects: [],
      }}
      validate={() => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        if (classes === undefined || classes === "" || classes === null) {
          setErrMessage(!values.selectClass)
          setErrMessage(true)
          setSubmitting(false)
        }
        else if (sub === undefined || sub === "" || sub === null) {
          setErrMessage1(true)
          setSubmitting(false)
        }
        else {
          const classData = {
            id: isUserId,
            classId: classId,
            subject: [selectedSujects.value].flat(),
          }
          AssignClasses(classData, setSubmitting);
        }
      }}
    >
      {({
        handleSubmit, isSubmitting
      }) => (
        <Form onSubmit={handleSubmit} style={styles.modal_form}>
          <Form.Group>
            <label htmlFor="Class">{Common.Class} </label>
            <Select
              defaultValue={selectedClass}
              onChange={(e) => {
                setSelectedClass(e)
                getAllSubjects(e)
                setClasses(e.value);
                setErrMessage(false)
              }}
              options={classOptions}
              placeholder="please select"
            />
            {errMessage && (<small className="text-danger">{VALIDATION.PLEASE_SELECT_A_CLASS}</small>)}
          </Form.Group>

          <Form.Group style={styles.radioMargin}>
            <label htmlFor="Subjects">{Common.Subjects} </label>
            <Select
              defaultValue={selectedSujects}
              onChange={(e) => {
                setSelectedSujects(e)
                setSub(e.value);
                setErrMessage1(false)
              }}
              options={selectedOverallSujects && selectedOverallSujects}
              placeholder="please select"
              isDisabled={selectedClass === null}
            />
            {errMessage1 && (<small className="text-danger">{VALIDATION.PLEASE_SELECT_A_SUBJECT}</small>)}
          </Form.Group>
          <Form.Group style={styles.button}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setAssignClass(false);
              }}
            >
              {Common.Cancel}
            </Button>&nbsp;
            <Button
              type="submit"
              variant="success"
              disabled={isSubmitting}
            >
              {Common.AddClass}
            </Button>
          </Form.Group>
        </Form>
      )}
    </Formik>
  );
}

export { AssignClass };